export default class Validator {
  static validateSurface(value) {
    if (!value) return false;
    const normalizedValue = value.replace(',', '.');

    const parts = normalizedValue.split('.');
    const integerPart = parts[0];
    const decimalPart = parts[1] || '';


    if (integerPart.length > 5) {
      return true;
    }

    if (decimalPart.length > 1) {
      return true;
    }

    return false;
  }
}
